import React from 'react'
import { connect, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import Alert from 'react-bootstrap/Alert'
import GroupsTable from '../../route/country/GroupsTable'

const closeSearchResults = () => ({
  type: 'CLEAR_SEARCH_RESULTS',
})

function SearchResults({
  search = {
    results: null,
    error: null,
  },
}) {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const onClose = () => {
    dispatch(closeSearchResults())
  }

  const onCourseGroupClicked = (group) => {
    console.log('Click group', group)
    navigate(`/course/${group.id}`)
    onClose()
  }

  const results = search.results
  const query = search.query
  console.log('Search results = ', results, query)
  if (results === null) return null

  if (results.length === 0) {
    return (
      <Alert variant="warning" onClose={onClose} dismissible>
        {`No result found for ${query}`}
      </Alert>
    )
  }
  console.log('We got', results.length, 'results')

  return (
    <Modal
      show={!!results}
      onHide={onClose}
      dialogClassName="search-result"
      backdrop="static"
      fullscreen={true}
      keyboard={false}
    >
      <Modal.Header closeButton>
        <Modal.Title>Search results</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <GroupsTable
          groups={results}
          onCourseGroupClicked={onCourseGroupClicked}
        />
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

const mapStateToProps = (state) => {
  return {
    search: state.search,
  }
}

export default connect(mapStateToProps)(SearchResults)
